import React, { Suspense } from 'react';

import ReactDOM from 'react-dom/client';
import './stili/index.css';
import './stili/App01.css';

import * as serviceWorkerRegistration from './serviceWorkerRegistration.ts';
import reportWebVitals from './reportWebVitals.ts';
import {
  createBrowserRouter,
  createMemoryRouter,
  RouterProvider,
  redirect,
  Outlet,

} from "react-router-dom";
import './i18n';

//import App from './pagine/App';
const App  = React.lazy(() => import( './pagine/App'));
const Persone  = React.lazy(() => import( './pagine/Persone'));
const GruppiPage  = React.lazy(() => import( './pagine/GruppiPage'));
const AttivitaPage  = React.lazy(() => import( './pagine/AttivitaPage'));
const DettPersone  = React.lazy(() => import( './pagine/DettPersone'));
const Config  = React.lazy(() => import( './pagine/Config'));

const ProfiliUtenti  = React.lazy(() => import( './pagine/ProfiliUtenti'));
const TestConfPage  = React.lazy(() => import( './pagine/TestConfPage'));
const ReportisticaTest  = React.lazy(() => import( './pagine/ReportisticaTest'));

const DettAttivita  = React.lazy(() => import( './pagine/DettAttivita'));
const GiocAttPage  = React.lazy(() => import( './pagine/GiocAttPage'));
const TeamPage  = React.lazy(() => import( './pagine/TeamPage'));
const PresenzePage  = React.lazy(() => import( './pagine/PresenzePage'));

const EsecTestPage  = React.lazy(() => import( './pagine/EsecTestPage'));
const ReportisticaTestGioc  = React.lazy(() => import( './pagine/ReportisticaTestGioc'));

const Reportistica  = React.lazy(() => import( './pagine/Reportistica'));
const ReportisticaGioc  = React.lazy(() => import( './pagine/ReportisticaGioc'));
const GraficoPage  = React.lazy(() => import( './pagine/GraficoPage'));

const TestSensori  = React.lazy(() => import( './pagine/TestSensori'));
const TestRapido  = React.lazy(() => import( './pagine/TestRapido.tsx'));
const AvatarPage  = React.lazy(() => import( './pagine/AvatarPage.jsx'));
const GamePage  = React.lazy(() => import( './pagine/GamePage.jsx'));
const PageContenuti  = React.lazy(() => import( './pagine/PageContenuti.tsx'));

const TestPage  = React.lazy(() => import( './pagine/TestPage.jsx'));
const SkillPage= React.lazy(() => import( './pagine/SkillPage.jsx'));
const AttivitaGiocatorePage  = React.lazy(() => import( './pagine/AttivitaGiocatore'));
const MyPage  = React.lazy(() => import( './pagine/MyPage'));



//const Ordini  = React.lazy(() => import( './pagine/Ordini'));

const HomeUtente  = React.lazy(() => import( './pagine/HomeUtente'));

// import i18n (needs to be bundled ;))

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
/*root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);*/

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,

    children: [
      
      {
        path: "/homeUtente",
        element: <Suspense fallback={<div>Loading...</div>}><HomeUtente /> </Suspense>,
      },
      {
        path: "/persone",
        element: <Suspense fallback={<div>Loading...</div>}><Persone /> </Suspense>,
      },
      {
        path: "/gruppi",
        element: <Suspense fallback={<div>Loading...</div>}><GruppiPage /> </Suspense>,
      },
      {
        path: "/attivita",
        element: <Suspense fallback={<div>Loading...</div>}><AttivitaPage /> </Suspense>,
      },
      {
        path: "/DettAttivita",
        element: <Suspense fallback={<div>Loading...</div>}><DettAttivita /> </Suspense>,
      },
      {
        path: "/DettPersone",
        element: <Suspense fallback={<div>Loading...</div>}><DettPersone /> </Suspense>,
      },
      {
        path: "/Config",
        element: <Suspense fallback={<div>Loading...</div>}><Config/> </Suspense>,
      },

      {
        path: "/ProfiliUtenti",
        element: <Suspense fallback={<div>Loading...</div>}><ProfiliUtenti/> </Suspense>,
      },
      {
        path: "/TestConfPage",
        element: <Suspense fallback={<div>Loading...</div>}><TestConfPage/> </Suspense>,
      },
      {
        path: "/giocAttPage",
        element: <Suspense fallback={<div>Loading...</div>}><GiocAttPage/> </Suspense>,
      },
      {
        path: "/TeamPage",
        element: <Suspense fallback={<div>Loading...</div>}><TeamPage/> </Suspense>,
      },
      {
        path: "/PresenzePage",
        element: <Suspense fallback={<div>Loading...</div>}><PresenzePage/> </Suspense>,
      },
      {
        path: "/EsecTestPage",
        element: <Suspense fallback={<div>Loading...</div>}><EsecTestPage/> </Suspense>,
      },
      {
        path: "/ReportisticaTest",
        element: <Suspense fallback={<div>Loading...</div>}><ReportisticaTest/> </Suspense>,
      },
      {
        path: "/ReportisticaTestGioc",
        element: <Suspense fallback={<div>Loading...</div>}><ReportisticaTestGioc/> </Suspense>,
      },

      {
        path: "/Reportistica",
        element: <Suspense fallback={<div>Loading...</div>}><Reportistica/> </Suspense>,
      },
      {
        path: "/ReportisticaGioc",
        element: <Suspense fallback={<div>Loading...</div>}><ReportisticaGioc/> </Suspense>,
      },
      {
        path: "/GraficoPage",
        element: <Suspense fallback={<div>Loading...</div>}><GraficoPage/> </Suspense>,
      }, 
  
      {
        path: "/AttivitaGiocatore",
        element: <Suspense fallback={<div>Loading...</div>}><AttivitaGiocatorePage/> </Suspense>,
      },
      {
        path: "/MyPage",
        element: <Suspense fallback={<div>Loading...</div>}><MyPage/> </Suspense>,
      },
      {
        path: "/testsensor",
        element: <Suspense fallback={<div>Loading...</div>}><TestSensori/> </Suspense>,
      },

      {
        path: "/TestRapido",
        element: <Suspense fallback={<div>Loading...</div>}><TestRapido/> </Suspense>,
      },
      {
        path: "/avatar",
        element: <Suspense fallback={<div>Loading...</div>}><AvatarPage/> </Suspense>,
      },
      {
        path: "/test",
        element: <Suspense fallback={<div>Loading...</div>}><TestPage/> </Suspense>,
      },
      {
        path: "/skill",
        element: <Suspense fallback={<div>Loading...</div>}><SkillPage/> </Suspense>,
      },
      {
        path: "/game",
        element: <Suspense fallback={<div>Loading...</div>}><GamePage/> </Suspense>,
      },
      {
        path: "/Contenuti",
        element: <Suspense fallback={<div>Loading...</div>}><PageContenuti/> </Suspense>,
      },
      /*{
        path: "/Ordini",
        element: <Suspense fallback={<div>Loading...</div>}><Ordini/> </Suspense>,
      }*/
      ]
  }
]);
root.render(
  <React.StrictMode>  
          <RouterProvider router={router} />
      </React.StrictMode>
);
//attenzione stric mode geneera due chiamate per useeffect ma non è attivo in produzione



// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();


